import React from 'react';

// Totaux lavés / impossibles / prévu, sur fond foncé (lignes de total).
export default function TotalsLavages({ t, color }) {
  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <b style={{ color: '#A5D6A7' }}>{t.laves}</b>
      <span style={{ color }}> / </span>
      <b style={{ color: '#EF9A9A' }}>{t.imp}</b>
      <span style={{ color }}> / </span>
      <span style={{ color }}>{t.prevu || '—'}</span>
    </span>
  );
}
